import { createVanIconComponent } from "./van"

const CashierOutlined = createVanIconComponent("cashier-o")
export default CashierOutlined
